export function DocsWovenHostPage() {
  return (
    <div className="docs-article">
      <p className="docs-eyebrow">Deploy</p>
      <h1 className="docs-page-title">Woven Host</h1>
      <p className="docs-lede">
        Woven Host is the account, entitlement, capacity, and product-lifecycle control plane for
        Woven. Realtime traffic goes directly to Woven over native QUIC or, when configured, browser
        WebTransport, independently of the Host control plane.
      </p>

      <div className="panel notice-panel docs-spatial-notice">
        <p className="page-prose">
          <strong>Lite is the active managed tier.</strong> New sign-ins remain guest with zero
          capacity until approved. The approved Lite default is 250 capacity units (Hz × allocated
          CCU); Pro defaults to 2,500 units and custom approved budgets are preserved. The public
          service represents the Host control plane; these docs do not claim public production
          managed Woven provisioning.
        </p>
      </div>

      <h2 className="docs-heading">Managed lifecycle</h2>
      <p className="docs-body">
        Host allocates a bounded namespace and session, provisions it through Woven&apos;s
        authenticated loopback admin API, stores encrypted client credentials, and reveals a
        generation-bound connection descriptor after recent authentication. It includes the native
        QUIC endpoint and, when enabled, the separate browser <code>webTransport.url</code> and
        trust metadata. Running is the authoritative state for client admission. Monitoring reports
        session admission and CCU state, while deletion revokes the scope and credential before
        releasing account capacity.
      </p>

      <h2 className="docs-heading">Locally validated client path</h2>
      <p className="docs-body">
        Local native QUIC end-to-end tests use the Rust client against Host and Woven with verified
        TLS and isolated Firebase Auth/Firestore emulators. Coverage includes provisioning,
        admission and queueing, subscription, publish and receive, isolation, deletion, and account
        teardown. These tests do not establish deployed-endpoint or browser-client validation.
      </p>

      <h2 className="docs-heading">Availability and Preview access</h2>
      <ul className="page-list">
        <li>
          <strong>Lite:</strong> active managed lifecycle, 250-unit default capacity budget, native
          QUIC, configured browser WebTransport, and Ephemeral events.
        </li>
        <li>
          <strong>Pro and Dedicated:</strong> Preview tiers with private founder access first.
        </li>
        <li>
          <strong>Online capabilities:</strong> Spatial Subspaces, managed spatial routing, browser
          WebTransport, and the TypeScript browser client.
        </li>
        <li>
          <strong>Capability Previews:</strong> persistence beyond Ephemeral and Inference.
        </li>
      </ul>
    </div>
  );
}
